module.exports = __webpack_public_path__ + "img/tanhao_icon.8356a8f0.png";